
import React from 'react';

const MissionValues = () => {
  return (
    <div className="mt-16">
      <h3 className="text-2xl font-bold mb-8 text-center">Our Mission & Values</h3>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div className="bg-white rounded-xl p-8 shadow-sm border border-border/50">
          <h4 className="text-xl font-semibold mb-4 text-primary">Our Mission</h4>
          <p className="text-muted-foreground mb-4">
            To empower organizations through custom technology solutions that perfectly 
            align with their unique requirements, enhancing productivity and driving innovation 
            in every sector we serve.
          </p>
          <p className="text-muted-foreground">
            We believe that hardware should be tailored to its purpose, not the other way around. 
            Our commitment is to create technology that feels purpose-built for your specific needs.
          </p>
        </div>
        
        <div className="bg-white rounded-xl p-8 shadow-sm border border-border/50">
          <h4 className="text-xl font-semibold mb-4 text-secondary">Core Values</h4>
          <ul className="space-y-3">
            <li className="flex items-start">
              <div className="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center mt-1 mr-3">
                <div className="w-2 h-2 rounded-full bg-primary"></div>
              </div>
              <p className="text-muted-foreground"><span className="font-medium text-foreground">Innovation:</span> Constantly pushing the boundaries of what's possible in hardware solutions.</p>
            </li>
            <li className="flex items-start">
              <div className="w-5 h-5 rounded-full bg-secondary/10 flex items-center justify-center mt-1 mr-3">
                <div className="w-2 h-2 rounded-full bg-secondary"></div>
              </div>
              <p className="text-muted-foreground"><span className="font-medium text-foreground">Quality:</span> Uncompromising commitment to excellence in every device we build.</p>
            </li>
            <li className="flex items-start">
              <div className="w-5 h-5 rounded-full bg-accent/10 flex items-center justify-center mt-1 mr-3">
                <div className="w-2 h-2 rounded-full bg-accent"></div>
              </div>
              <p className="text-muted-foreground"><span className="font-medium text-foreground">Client-Centric:</span> Putting customer needs at the center of our design and service process.</p>
            </li>
            <li className="flex items-start">
              <div className="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center mt-1 mr-3">
                <div className="w-2 h-2 rounded-full bg-primary"></div>
              </div>
              <p className="text-muted-foreground"><span className="font-medium text-foreground">Sustainability:</span> Committed to environmentally responsible manufacturing and product lifecycle management.</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MissionValues;
